import {
  ListJobsRequest,
  DeleteJobsRequest,
  Campaign,
} from "../../appstore/models";

// import { S3 } from "@aws-sdk/client-s3";
// import { APIGatewayClient } from "@aws-sdk/client-api-gateway";
// import apigClientFactory from "../../common/api-gateway-client/apigClient";
// import { getCredentials, getAwsRegion } from "../../common/credentials";

/*
export const getJobsApi = async () => {
  const credentials = getCredentials();
  const awsRegion = getAwsRegion();
  
  //const s3Client = new S3({
  //  region: awsRegion,
  //  credentials,
  //});
  //s3Client
  //  .listObjects({ Bucket: "oversightml-test-299226988948-us-east-1" })
  //  .then((x) => console.log("yeee", x));

  try {
  } catch (e) {}
  const apiGateayClient = new APIGatewayClient({
    region: awsRegion,
    credentials,
  });
  const client = apigClientFactory.newClient({
    invokeUrl: process.env.REACT_APP_API_GATEWAY_ENDPOINT,
    region: process.env.REACT_APP_AWS_DEFAULT_REGION,
    accessKey: credentials.accessKeyId,
    secretKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
  });
  var pathParams = {
    jobArn:
      "arn:aws:oversightml:us-east-1:299226988948:ipj/Job-2021-05-21T13:23:54.121858",
  };
  // Template syntax follows url-template https://www.npmjs.com/package/url-template
  var pathTemplate = "/processing/geo-campaigns/{jobArn}";
  var method = "GET";
  var additionalParams = {};
  var body = {
    //This is where you define the body of the request
  };

  client
    .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
    .then(function (result) {
      console.log("APIG SUCCESS!!! ", result);
      //This is where you would put a success callback
    })
    .catch(function (result) {
      console.log("APIG ERROR!!! ", result);
      //This is where you would put an error callback
    });
  // apiGateayClient.send();
};
*/

export const getJobs = async (
  allJobs: Campaign[],
  request: ListJobsRequest
) => {
  // To be modified with "await fetch(url, request)"
  let filteredJobs = allJobs.filter((job) => {
    const jobSubmitTimeMilliseconds = new Date(job.DateCreated).getTime();
    const requestSubmitTimeBeforeMilliseconds = request.Filter.SubmitTimeBefore
      ? new Date(request.Filter.SubmitTimeBefore).getTime()
      : Infinity;
    const requestSubmitTimeAfterMilliseconds = request.Filter.SubmitTimeAfter
      ? new Date(request.Filter.SubmitTimeAfter).getTime()
      : 0;
    const submitBetweenMatch =
      jobSubmitTimeMilliseconds < requestSubmitTimeBeforeMilliseconds &&
      jobSubmitTimeMilliseconds > requestSubmitTimeAfterMilliseconds;
    const nameMatch = request.Filter.JobName
      ? job.JobName.toLowerCase().indexOf(
          request.Filter.JobName.toLowerCase()
        ) > -1
      : true;
    const statusMatch = request.Filter.JobStatus
      ? job.Status.toLowerCase() === request.Filter.JobStatus.toLowerCase()
      : true;

    return submitBetweenMatch && nameMatch && statusMatch;
  });

  return {
    FeatureDetectionJobPropertiesList: filteredJobs.slice(
      (request.PageNumber - 1) * request.MaxResults,
      request.PageNumber * request.MaxResults
    ),
    NextToken: "NextTokenHere",
    TotalCount: filteredJobs.length,
  };
};

export const deleteJobs = (request: DeleteJobsRequest) => {
  /*
  let jobsCopy = JOBS.filter((job) => {
    return request.JobIDs.indexOf(job.id) === -1;
  });
  JOBS = [...jobsCopy];
  */
  return {
    status: "ok",
    message: "Deleted successfully",
  };
};
